import { useEffect, useRef, useState } from "react";
import { API_BASE } from "../../lib/apiBase";

const BACKEND = API_BASE;

export default function AccountComplete() {
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const handoff = params.get("handoff");
    if (!handoff) {
      setError("missing_handoff");
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${BACKEND}/api/account/oauth/claim`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ handoff }),
        });
        if (!res.ok) {
          setError("claim_failed");
          return;
        }
        const data = await res.json();
        const dest = data?.return_path || "/account/index";
        // Full navigation so AccountProvider re-reads /me with the new cookies.
        window.location.replace(dest);
      } catch {
        setError("network");
      }
    })();
  }, []);

  if (error) {
    return (
      <div
        data-testid="account-complete-error"
        style={{
          minHeight: "100vh",
          background: "#0A0A0A",
          color: "#fff",
          padding: "48px 24px",
          fontFamily: "ui-sans-serif,system-ui,-apple-system,sans-serif",
        }}
      >
        <div style={{ maxWidth: 520, margin: "80px auto" }}>
          <h1 style={{ fontSize: 22, textTransform: "uppercase", letterSpacing: ".01em", margin: "0 0 12px" }}>
            Sign-in interrupted
          </h1>
          <p style={{ color: "rgba(255,255,255,.7)", lineHeight: 1.6, fontSize: 14, margin: "0 0 20px" }}>
            We couldn't finish your sign-in. This can happen if the sign-in window stayed open for too long. Try again.
          </p>
          <a
            href="/account/login"
            data-testid="account-complete-retry"
            style={{
              display: "inline-block",
              background: "#F59E0B",
              color: "#000",
              textDecoration: "none",
              padding: "12px 20px",
              fontFamily: "ui-monospace,monospace",
              fontSize: 11,
              letterSpacing: ".18em",
              textTransform: "uppercase",
            }}
          >
            Try again →
          </a>
          <p style={{ marginTop: 24, fontFamily: "ui-monospace,monospace", fontSize: 10, color: "rgba(255,255,255,.35)", letterSpacing: ".14em", textTransform: "uppercase" }}>
            Reason: {error}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="account-complete-loading"
      style={{
        minHeight: "100vh",
        background: "#0A0A0A",
        color: "rgba(255,255,255,.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "ui-monospace,monospace",
        fontSize: 11,
        letterSpacing: ".2em",
        textTransform: "uppercase",
      }}
    >
      Signing you in…
    </div>
  );
}
